@if (successCount() > 0 || warningCount() > 0) {
  <div class="flex flex-col gap-0.75">
    @if (successCount() > 0) {
      <span mibBadge theme="success"
        >{{ successCountLimited() }}<span class="sr-only">generated contents</span></span
      >
    }
    @if (warningCount() > 0) {
      <span mibBadge theme="warning"
        >{{ warningCountLimited() }}<span class="sr-only">contents in error</span></span
      >
    }
  </div>
}
